import { api } from "../api";

/**
 * ticketsfindAllByActivated - Function that finds on database all tickets
 * /tickets/{status} 
 * method GET 
 * @async-function
 */
const ticketsfindAllByActivated = async (token: string, managerId: number, status: string, page: number, size: number) => {
    const response = await api.get(
        `/tickets/${managerId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default ticketsfindAllByActivated;